<div class="cc-bill-container fade-in">
    <!-- STEP 1: SELECT AMOUNT -->
    <ng-container *ngIf="step === 'select-amount'">
        <div class="cc-header">
            <h2>Credit Card Bill Payment</h2>
            <button class="close-btn" (click)="goBack()">
                <img src="assets/icons/close-48.png" alt="Close" />
            </button>
        </div>

        <div class="cc-body">
            <h3 class="section-label">Pay Amount</h3>

            <div class="options-grid">
                <div class="option-card" [class.selected]="selectedOption === 'min'" (click)="selectOption('min')">
                    <div class="option-title">Minimum Due</div>
                    <div class="option-desc">To avoid late payment penalties</div>
                    <div class="option-amount">₹{{minDue | number:'1.0-0'}}</div>
                </div>

                <div class="option-card" [class.selected]="selectedOption === 'full'" (click)="selectOption('full')">
                    <div class="option-title">Full Amount</div>
                    <div class="option-desc">Pay total outstanding balance</div>
                    <div class="option-amount">₹{{totalDue | number:'1.0-0'}}</div>
                </div>
            </div>

            <div class="custom-amount-section">
                <label>Custom Amount</label>
                <div class="amount-input-wrapper">
                    <input type="number" [(ngModel)]="customAmount" placeholder="0.00" (focus)="onCustomAmountFocus()">
                    <span class="currency">INR</span>
                </div>
                <div class="amount-hint">Amount must be between ₹{{minDue | number:'1.0-0'}} and ₹{{totalDue |
                    number:'1.0-0'}}</div>
            </div>
        </div>
    </ng-container>


</div>
<!-- STEP 2: REVIEW -->
<ng-container *ngIf="step === 'review'">
    <div class="cc-bill-container review fade-in">
        <!-- Card Selection Section -->
        <div class="review-section-container">
            <div class="review-section-label">Select card for payment</div>

            <!-- Source Card Selection -->
            <div class="source-card-box">
                <div class="source-info">
                    <span class="source-name">{{selectedPayCard.bank}}</span>
                    <span class="source-num">**** {{selectedPayCard.number}}</span>
                </div>
                <button class="change-btn" (click)="toggleDropdown()">
                    <span class="txt">Change</span>
                    <div class="arrow-icon">
                        <img src="assets/icons/direction-down20x20.svg" alt="v"
                            [style.transform]="isDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)'"
                            style="transition: transform 0.2s;">
                    </div>
                </button>

                <!-- Dropdown Menu -->
                <div class="card-dropdown" *ngIf="isDropdownOpen" (click)="$event.stopPropagation()">
                    <div class="dropdown-header">
                        <span>SELECT CARD</span>
                    </div>
                    <div class="dropdown-scroll">
                        <div class="dropdown-item" *ngFor="let card of availableCards"
                            [class.item-selected]="selectedPayCard.id === card.id" (click)="selectPayCard(card)">
                            <div class="card-icon-box">
                                <img [src]="card.icon || 'assets/icons/card.svg'" alt="card"
                                    onerror="this.src='assets/icons/card.svg'">
                            </div>
                            <div class="card-item-info">
                                <div class="card-name-row">
                                    <span class="bank-name">{{card.bank}}</span>
                                    <span class="active-badge" *ngIf="selectedPayCard.id === card.id">ACTIVE</span>
                                </div>
                                <span class="card-num">**** {{card.number}}</span>
                            </div>
                            <div class="check-icon" *ngIf="selectedPayCard.id === card.id">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M3 8L6.5 11.5L13 4.5" stroke="#E7733A" stroke-width="1.8"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <hr>
    <div class="cc-bill-container review fade-in">

        <div class="review-details-container">
            <!-- Review Details Section -->
            <h3>Review</h3>
            <div class="review-card">
                <div class="review-row">
                    <span class="label">Bank</span>
                    <span class="value">{{selectedPayCard.bank}}</span>
                </div>
                <div class="review-row">
                    <span class="label">Credit Card</span>
                    <span class="value">**** {{selectedPayCard.number}}</span>
                </div>
                <div class="review-row">
                    <span class="label">Payment amount</span>
                    <span class="value">₹{{payAmount | number:'1.0-0'}}</span>
                </div>
                <div class="review-row">
                    <span class="label">Fee</span>
                    <span class="value">₹25.00</span>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<!-- Footer: outside cc-bill-container so it has no container background -->
<ng-container *ngIf="step === 'select-amount'">
    <div class="cc-footer">
        <button class="btn-back" (click)="goBack()">Back</button>
        <button class="btn-next" [disabled]="!isValid" (click)="proceed()">Next</button>
    </div>
</ng-container>

<ng-container *ngIf="step === 'review'">
    <div class="cc-footer review-footer">
        <button class="btn-back" (click)="goBack()">Cancel</button>
        <button class="btn-next" (click)="confirm()">Send</button>
    </div>
</ng-container>